import { Overline, Card } from "./shared";

export const MarketingResult = ({ r }) => (
  <div data-testid="bb-result-marketing" className="grid grid-cols-1 lg:grid-cols-2 gap-5">
    <Card>
      <Overline>Google Ads</Overline>
      {(r.google_ads || []).map((a) => (
        <div key={a.headline} className="mb-3">
          <div className="font-bold text-sm text-[#1a0dab]">{a.headline}</div>
          <div className="text-xs text-[#52525b]">{a.description}</div>
        </div>
      ))}
      <Overline>Facebook / IG Ads</Overline>
      {(r.facebook_ads || []).map((a) => (
        <div key={a.hook} className="mb-3 border-l-2 border-[#ff3b30] pl-3">
          <div className="font-bold text-sm">{a.hook}</div>
          <div className="text-xs text-[#52525b]">{a.body}</div>
          <div className="font-mono text-[10px] mt-1 uppercase">[{a.cta}]</div>
        </div>
      ))}
    </Card>
    <Card>
      <Overline>TikTok hooks</Overline>
      <ul className="space-y-2 text-sm mb-5">
        {(r.tiktok_hooks || []).map((h) => <li key={h}>🎬 {h}</li>)}
      </ul>
      <Overline>SEO keywords</Overline>
      <div className="flex flex-wrap gap-2 mb-4">
        {(r.seo?.keywords || []).map((k) => (
          <span key={k} className="font-mono text-xs bg-[#f4f4f5] border border-black px-2 py-1">{k}</span>
        ))}
      </div>
      <Overline>Content ideas</Overline>
      <ul className="space-y-1 text-sm">
        {(r.seo?.content_ideas || []).map((c) => <li key={c}>· {c}</li>)}
      </ul>
    </Card>
    <Card className="lg:col-span-2">
      <Overline>Email sequence</Overline>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 mb-4">
        {(r.email_sequence || []).map((e) => (
          <div key={e.subject} className="border border-black p-3">
            <div className="font-mono text-[10px] text-[#52525b]">DAY {e.day}</div>
            <div className="font-bold text-sm mt-1">{e.subject}</div>
            <div className="text-xs text-[#52525b] mt-1">{e.goal}</div>
          </div>
        ))}
      </div>
      <div className="font-mono text-xs text-[#52525b]">
        📰 Press: &ldquo;{r.press_release_headline}&rdquo; · 🤝 {r.influencer_strategy}
      </div>
    </Card>
  </div>
);
